import { Component, OnInit } from '@angular/core';
import { Genre } from 'src/models/genre';
import { Router, ActivatedRoute } from '@angular/router';
import { ListStreamsI } from '../../base/list-streams/list-streams-i';
import { Stream } from 'src/models/stream';
import { Observable } from 'rxjs';
import { StreamService } from 'src/app/services/stream.service';

@Component({
  selector: 'app-genres',
  templateUrl: './genres.component.html',
  styleUrls: ['./genres.component.scss']
})
export class GenresComponent implements OnInit, ListStreamsI {
  state$: Observable<object>;
  
  public categories = new Array<Genre>();

  public genreId: number;

  constructor(private activatedRoute: ActivatedRoute, private streamService: StreamService) {}

  ngOnInit() {
    this.streamService.getCategories().subscribe((value: Genre[]) => {
      this.categories = value;
    });

    this.activatedRoute.queryParams.subscribe(params => {
      this.genreId = params['id'];
    });
  }

  public getHeadline(): string {
    const category = this.categories.find((category: Genre) => category.id === this.genreId);

    return category !== undefined ? category.name : 'Alle';
  }
  public getStreamsObservable(start: number, itemsPerPage: number): Observable<Stream[]> {
    const observable = this.genreId !== undefined ? this.streamService.getStationsByCategory(this.genreId, start, itemsPerPage)
                                                    : this.streamService.getTopStations(start, itemsPerPage);

    return observable;
  }

}
